import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";



// Async fetch from API
export const fetchPropertyTypes = createAsyncThunk(
  "propertyTypes/fetch",
  async () => {
    const res = await api.get("/api/property-types");
   
    return res.data;
  }
);

const propertyTypeSlice = createSlice({
  name: "propertyTypes",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPropertyTypes.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPropertyTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchPropertyTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default propertyTypeSlice.reducer;
